import axiosInstance from './axiosInstance';
import { Deduction, CreateDeductionDto, UpdateDeductionDto, ApproveDeductionDto, DeductionSummary, DeductionFilters } from '../types/deductions.types';

const API_URL = '/Deductions';

export const deductionsService = {
  getAll: async (filters?: DeductionFilters): Promise<Deduction[]> => {
    const params = new URLSearchParams();
    if (filters?.branchId) params.append('branchId', filters.branchId.toString());
    if (filters?.employeeId) params.append('employeeId', filters.employeeId.toString());
    if (filters?.month) params.append('month', filters.month.toString());
    if (filters?.year) params.append('year', filters.year.toString());
    if (filters?.status) params.append('status', filters.status);

    const response = await axiosInstance.get(`${API_URL}?${params.toString()}`);
    return response.data;
  },

  getById: async (id: number): Promise<Deduction> => {
    const response = await axiosInstance.get(`${API_URL}/${id}`);
    return response.data;
  },

  getSummary: async (branchId?: number, month?: number, year?: number): Promise<DeductionSummary[]> => {
    const params = new URLSearchParams();
    if (branchId) params.append('branchId', branchId.toString());
    if (month) params.append('month', month.toString());
    if (year) params.append('year', year.toString());

    const response = await axiosInstance.get(`${API_URL}/summary?${params.toString()}`);
    return response.data;
  },

  create: async (data: CreateDeductionDto): Promise<Deduction> => {
    const response = await axiosInstance.post(`${API_URL}`, data);
    return response.data;
  },

  update: async (data: UpdateDeductionDto): Promise<Deduction> => {
    const response = await axiosInstance.put(`${API_URL}/${data.deductionId}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  acknowledge: async (id: number): Promise<Deduction> => {
    const response = await axiosInstance.post(`${API_URL}/${id}/acknowledge`);
    return response.data;
  },

  approve: async (data: ApproveDeductionDto): Promise<Deduction> => {
    const response = await axiosInstance.post(`${API_URL}/approve`, data);
    return response.data;
  }
};